<template>
  <div
    class="quick-search"
    aria-label="Search this website">
    <span
      class="search-icon"
      @click="submit">
      <font-awesome-icon
        :icon="['far', 'search']"
        role="presentation"></font-awesome-icon>
    </span>
    <input
      v-model="value"
      :placeholder="placeholder"
      type="text"
      aria-label="Enter your search query and press return to submit"
      @keyup.enter="submit">
  </div>
</template>

<script>
import { mapState } from "vuex";
import URI from "urijs";

export default {
  name: "QuickSearch",
  props: {
    filterAlias: {
      type: String,
      default: "query",
    },
    url: {
      type: String,
      default: "/search",
    },
    placeholders: {
      type: Array,
      default: () => {},
    },
  },
  data () {
    return {
      value: "",
      placeholder: "Search...",
      currentIncrement: 0,
      timeBetweenPlaceholders: 2000,
      timeBetweenCharacters: 60,
    };
  },
  computed: {
    freeTextFilterValue () {
      let result = "";

      const [foundFilters] = this.filters.filter(
        ( x ) => x.alias === this.filterAlias,
      );

      if ( foundFilters ) {
        result = foundFilters.value;
      }

      return result;
    },
    ...mapState( {
      filters: state => state.search.filters,
    } ),
  },
  created () {
    if ( this.freeTextFilterValue ) {
      this.value = this.freeTextFilterValue;
    }

    if ( this.placeholders != null && this.placeholders.length > 0 ) {
      this.loadNextPlaceholder();
    }
  },
  methods: {
    submit () {
      if ( this.value ) {
        const queryObject = {};
        queryObject[this.filterAlias] = this.value;

        const newUrl = URI( this.url ).setQuery( queryObject );
        window.location = newUrl;
      }
    },
    loadNextPlaceholder ( time ) {
      let currentIntervalTime = time;
      if ( !time ) {
        // Get the new placeholder value
        const currentPlaceholder = this.placeholders[this.currentIncrement];

        // Determine how long it would take to show the new placeholder
        const timeForAnimation = currentPlaceholder.length * this.timeBetweenCharacters;
        currentIntervalTime = timeForAnimation + this.timeBetweenPlaceholders;
      }

      // Get the new placeholder value
      const newPlaceholder = this.placeholders[this.currentIncrement];

      // Determine how long it would take to show the new placeholder
      const timeForAnimation = newPlaceholder.length * this.timeBetweenCharacters;
      const nextIntervalTime = timeForAnimation + this.timeBetweenPlaceholders;

      // Set a timeout and animate the placeholder
      setTimeout( () => {
        this.animatePlaceholder( newPlaceholder );
        this.loadNextPlaceholder( nextIntervalTime );
      }, currentIntervalTime );

      // Increment current placeholder position
      // Loop back around to zero if needed
      this.currentIncrement += 1;
      if ( this.placeholders.length <= this.currentIncrement ) {
        this.currentIncrement = 0;
      }
    },
    animatePlaceholder ( placeholder ) {
      const characters = placeholder.split( "" );

      this.placeholder = "";
      characters.forEach( ( x, index ) => {
        setTimeout( () => {
          this.placeholder += x;
        }, this.timeBetweenCharacters * index );
      } );
    },
  },
};
</script>

<style lang="less" scoped>
.quick-search {
  position: relative;
}

.search-icon {
  position: absolute;
  right: 20px;
  top: calc( 50% - 17px );
  font-size: 24px;
  color: #b2b2b2;
  cursor: pointer;

  &:hover {
    color: #888;
  }
}
</style>
